import { computed, makeObservable } from 'mobx';
import { Filtro } from './Filtro';

export default class FiltroUltimoAndamento extends Filtro {
    tipo = 'selecao';
    exibicao = 'select';
    selecaoMultipla = true;

    get label() {
        return 'Último andamento';
    }

    constructor(props) {
        super(props);

        makeObservable(this, {
            carregandoDadosComplementares: computed
        });
    }

    getValorOpcao(registro) {
        return registro && registro.detalhes && registro.detalhes.ultimoAndamento;
    }

    getDescricao(valor) {
        return valor ? `${valor.id} - ${valor.descricao}` : '';
    }

    equals(valor1, valor2) {
        return valor1 && valor2 && valor1.id === valor2.id;
    }

    get isHabilitado() {
        return this.store.rootStore.parametroStore.isOrgaoTST && this.store.existeSessaoSIJ;
    }

    get carregandoDadosComplementares() {
        return this.store.carregandoUltimosAndamentos;
    }

    renderCarregando() {
        return this.renderCircularProgress('último andamento dos processos');
    }
}
